export type { CompoundRecordComposerCandidateIdType } from "~/common/types/graphql.generated";

export const DECISIONS = {
  SIMILAR: "similar",
  NOT_SIMILAR: "not similar",
  INCONCLUSIVE: "inconclusive",
} as const;

export const VALID_DECISIONS: readonly string[] = Object.values(DECISIONS);
export type Decision = (typeof DECISIONS)[keyof typeof DECISIONS];

export const COMPOUND_RECORD_COMPOSER_CANDIDATE_ID_TYPES = {
  RECORD_METADATA_ID: "RECORD_METADATA_ID",
  RECORD_ID: "RECORD_ID",
} as const;

export function isValidDecision(value: string): value is Decision {
  return VALID_DECISIONS.includes(value);
}

export interface InsertedRecord {
  recordType: string;
  categoryId: string;
  recordIds: string[];
  properties: {
    mainCandidateId?: string;
    compoundCandidateId?: string;
    decision?: string;
    memo?: string;
  };
  error?: string;
}
